import TaskResource from './TaskResource';

export default {
    task: TaskResource,
};

export type TaskResources = {
    task: TaskResource,
};
